import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';


const RegisterWhatCapturedInterestDropdown = (props) => {

const useStyles = makeStyles((theme) => ({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
  }));
  

    const classes = useStyles();

  
const handleChange = props.handleChange
const formState = props.formState

    return (
      <div>
        <FormControl className={classes.formControl}>
          
          <Select
            className="newUserInput"
            name="interestSelection"
            value={formState.interestSelection}
            onChange={handleChange}
            displayEmpty
          >
            <MenuItem value="">
              <em>Please select an option</em>
            </MenuItem>
            <MenuItem value={"Browser Security"}>Browser Security</MenuItem>
            <MenuItem value={"Awareness Training"}>Awareness Training</MenuItem>
            <MenuItem value={"Both"}>Both</MenuItem>
          </Select>
        </FormControl>
       
      </div>
    );

}; export default RegisterWhatCapturedInterestDropdown